import React from 'react';
import { Box } from '@mui/material';

const STATUS_VARIANTS = {
  enabled: {
    bgcolor: '#DCFCE7',
    color: '#166534',
    label: 'Enabled',
  },
  disabled: {
    bgcolor: '#F3F4F6',
    color: '#6B7280',
    label: 'Disabled',
  },
};

const ConfirmationStatusBadge = ({ enabled }) => {
  const variant = enabled ? STATUS_VARIANTS.enabled : STATUS_VARIANTS.disabled;

  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        px: 1.25,
        py: 0.35,
        borderRadius: '999px',
        bgcolor: variant.bgcolor,
        color: variant.color,
        fontSize: '0.8125rem',
        fontWeight: 600,
        lineHeight: 1.4,
      }}
    >
      {variant.label}
    </Box>
  );
};

export default ConfirmationStatusBadge;
